import React, { FC } from 'react';
import { SFooter } from './style';

const Footer: FC = () => <SFooter />;

export default Footer;
